import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserRateRequestDto } from 'src/api/FiretrolApiClient';
import { userRateApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useUpdateUserRate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: number;
      request: UserRateRequestDto;
    }) => userRateApiClient.update(id, request),
    meta: {
      successMessage: 'User rate updated successfully',
      suppressErrorToast: true,
    },
    onSettled: () => invalidateFor('userRate.update', qc),
  });
}
